module.exports = __webpack_public_path__ + "static/img/15.6be0853.png";


//////////////////
// WEBPACK FOOTER
// ./src/project/articleProject/images/qlxj/15.png
// module id = f8eT
// module chunks = 6